import ContactForm from '@/components/domains/self-service/contact/ContactForm.vue';

export const INTERPRETATION_QNA = [
  {
    question: 'qna_interp_audio_saved_q',
    answer: ['qna_interp_audio_saved_a1', 'qna_interp_audio_saved_a2'],
  },
  {
    question: 'qna_interp_history_not_saved_q',
    answer: ['qna_interp_history_not_saved_a1', 'qna_interp_history_not_saved_a2'],
  },
  {
    question: 'qna_interp_ai_training_q',
    answer: ['qna_interp_ai_training_a1'],
  },
  // {
  //   question: 'qna_interp_mobile_supported_q',
  //   answer: ['qna_interp_mobile_supported_a1'],
  // },
  {
    question: 'qna_interp_multi_speakers_multi_lang_q',
    answer: ['qna_interp_multi_speakers_multi_lang_a1', 'qna_interp_multi_speakers_multi_lang_a2'],
  },
  {
    question: 'qna_interp_supported_languages_count_q',
    answer: ['qna_interp_supported_languages_count_a1', 'qna_interp_supported_languages_list_a2'],
  },
  {
    question: 'qna_interp_event_use_q',
    answer: ['qna_interp_event_use_a1', 'qna_interp_event_use_a2'],
  },
];

export const ACCOUNT_SUBSCRIPTION_QNA = [
  {
    question: 'qna_account_delete_q',
    answer: ['qna_account_delete_a1_mobile'],
  },
  // TODO: 인앱 결제 추가 후, 주석 제거 필요
  // {
  //   question: 'qna_subscription_cancel_refund_change_q',
  //   answer: [
  //     'qna_subscription_cancel_refund_change_a1',
  //     'qna_subscription_cancel_refund_change_a2',
  //     'qna_subscription_cancel_refund_change_a3',
  //   ],
  // },
  // {
  //   question: 'qna_payment_method_change_q',
  //   answer: ['qna_payment_method_change_a1', 'qna_payment_method_change_a2'],
  // },
  {
    question: 'qna_contact_support_q',
    answer: ['qna_contact_support_a1'],
    component: ContactForm,
  },
];
